import { useEffect, useState } from "react";
import {
  A,
  B,
  C,
  D,
  E,
  F,
  G,
  H,
  I,
  J,
  K,
  L,
  M,
  N,
  O,
  P,
  R,
  S,
  T,
  U,
  V,
  W,
  X,
  Y,
  Z,
} from "./letters";

const DefaultImage = ({ src, alt, className, letter, style }: any) => {
  const getImg = () => {
    const letterUpper = letter?.toUpperCase();
    switch (letterUpper) {
      case "A":
        return A;
      case "B":
        return B;
      case "C":
        return C;
      case "D":
        return D;
      case "E":
        return E;
      case "F":
        return F;
      case "G":
        return G;
      case "H":
        return H;
      case "I":
        return I;
      case "J":
        return J;
      case "K":
        return K;
      case "L":
        return L;
      case "M":
        return M;
      case "N":
        return N;
      case "O":
        return O;
      case "P":
        return P;
      case "R":
        return R;
      case "S":
        return S;
      case "T":
        return T;
      case "U":
        return U;
      case "V":
        return V;
      case "W":
        return W;
      case "X":
        return X;
      case "Y":
        return Y;
      case "Z":
        return Z;
      default:
        return null;
    }
  };

  // Determine the image path based on whether `src` is provided or not
  const imagePath = src ? src : getImg();

  return (
    <img
      src={imagePath}
      alt={alt}
      className={className}
      onError={(e: any) => (e.currentTarget.src = getImg() || "")}
      style={style || {}}
    />
  );
};

export default DefaultImage;
